import { defineStore } from "pinia";

export const usecommonStore = defineStore({
  id: "common",

  state: () => {
    return {
      sportType: "football",
      siteName: "xoilacz",
      sessionId: "",
      teamId: "",
      playerId: "",
    };
  },

  getters: {
    getSportType: (state) => {
      return state.sportType;
    },
    getSiteName: (state) => {
      return state.siteName;
    },
    getSessionId: (state) => {
      return state.sessionId;
    },
    getTeamId: (state) => {
      return state.teamId;
    },
    getPlayerId: (state) => {
      return state.playerId;
    },
  },

  actions: {
    async setSportType(value: string) {
      this.sportType = value;
    },
    async setSiteName(value: string) {
      this.siteName = value;
    },
    async setSessionId(value: string) {
      this.sessionId = value;
    },
    async setTeamId(value: string) {
      this.teamId = value;
    },
    async setPlayerId(value: string) {
      this.playerId = value;
    },
  },
});
